// oxlint-disable no-process-env
import { z } from 'zod'

import { createEnv } from '@isoapp/common/env/createEnv'

export const env = createEnv({
  client: {
    NEXT_PUBLIC_DISTRICT_GRAPH_URL: z.url(),
    NEXT_PUBLIC_DISTRICT_DJANGO_URL: z.url().optional(),
    NEXT_PUBLIC_DISTRICT_AGENTS_API_URL: z.url().optional(),
    NEXT_PUBLIC_DISTRICT_ADMIN_API_URL: z.url().optional(),
    NEXT_PUBLIC_DISTRICT_SHIPHERO_API_URL: z.url().optional(),
  },
  experimental__runtimeEnv: {
    NEXT_PUBLIC_DISTRICT_GRAPH_URL: process.env.NEXT_PUBLIC_DISTRICT_GRAPH_URL,
    NEXT_PUBLIC_DISTRICT_DJANGO_URL: process.env.NEXT_PUBLIC_DISTRICT_DJANGO_URL,
    NEXT_PUBLIC_DISTRICT_AGENTS_API_URL: process.env.NEXT_PUBLIC_DISTRICT_AGENTS_API_URL,
    NEXT_PUBLIC_DISTRICT_ADMIN_API_URL: process.env.NEXT_PUBLIC_DISTRICT_ADMIN_API_URL,
    NEXT_PUBLIC_DISTRICT_SHIPHERO_API_URL: process.env.NEXT_PUBLIC_DISTRICT_SHIPHERO_API_URL,
  },
})
